module.exports = __webpack_public_path__ + "static/media/IS.4648e68c.svg";